import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, getApi } from 'services/rotasp/api';
import { PATH_CIN } from 'services/rotasp/path';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { Types } from './types';

// ACTIONS
import {
	consultarCpfCinResponsavelSuccess,
	consultarCpfCinResponsavelFailure,
} from './actions';

function* consultarCpfCinResponsavelRequest(request: ReducerActionRotaSP) {
	const { payload, token }: { payload: string; token?: string } = request;
	const statusAllowed = [200, 204];

	const response: ApiResponse = yield call(
		getApi,
		token || '',
		PATH_CIN,
		`cpf/${payload}`,
		undefined,
		undefined,
		undefined,
		undefined,
		undefined,
		statusAllowed,
	);

	if (response.status === 200) {
		yield put(consultarCpfCinResponsavelSuccess(response.data));
	} else {
		yield put(consultarCpfCinResponsavelFailure(response));
	}
}

export default all([
	takeLatest(
		Types.CONSULTAR_CPF_CIN_RESPONSAVEL_REQUEST,
		consultarCpfCinResponsavelRequest,
	),
]);
